<template lang="pug">
  div
    | Nous n'avons pas pu envoyer votre demande :
    ul.mb-0.pl-4(v-if="Object.keys(errors).length")
      li(v-for="error in errors") {{ error[0] }}
</template>

<script>

  export default {
    props: {
      errors: {
        type: Object,
        default: undefined
      }
    }
  }
</script>
